import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-zewotherm-lightgrey" }, null, -1)

import { IonTabBar, IonContent, IonTabButton, IonTabs, IonBackButton, IonButtons, IonHeader, IonToolbar, IonTitle, IonIcon, IonPage, IonRouterOutlet, onIonViewWillEnter } from '@ionic/vue';
import { document, folder, checkbox, people, chatbubble } from 'ionicons/icons';
import { onMounted, ref } from 'vue'
import { useCompany } from '@/store/company'
import { useRoute } from 'vue-router';
import { useSelectedProject } from '@/store/selectedProject';
import { loadingController } from '@ionic/vue';
import { useCurrentUser } from '@/store/currentUser'


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailPage',
  setup(__props) {

const selectedProjectStore = useSelectedProject()
const route = useRoute()
const urlWithId = ref('/detail/' + route.params.id)
const companyStore = useCompany()
const showData = ref(false)
const currentUserStore = useCurrentUser()

onMounted(async() => {
  selectedProjectStore.$reset()
  const loading = await loadingController.create({
    message: "Lade Projektdaten..."
  })
  await loading.present()
  try {
    await selectedProjectStore.setAllViaApi(route.params.id.toString(), currentUserStore.jwtKey, companyStore.activeCompany.id.toString())
    showData.value = true
  } catch (e) {
    console.error(e)
  } finally {
    await loading.dismiss()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    text: "",
                    style: {"--color":"#444444"},
                    "default-href": "/"
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(route).name?.toString()) + ", " + _toDisplayString(_unref(selectedProjectStore).project.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          (showData.value)
            ? (_openBlock(), _createBlock(_unref(IonTabs), { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRouterOutlet)),
                  _hoisted_1,
                  _createVNode(_unref(IonTabBar), {
                    class: "px-3",
                    slot: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonTabButton), {
                        style: _normalizeStyle('--color-selected: ' + _unref(companyStore).activeCompany.color),
                        tab: "Data",
                        href: urlWithId.value + '/data' 
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(document) }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["style", "href"]),
                      _createVNode(_unref(IonTabButton), {
                        style: _normalizeStyle('--color-selected: ' + _unref(companyStore).activeCompany.color),
                        tab: "Checkpoints",
                        href: urlWithId.value + '/checkpoints'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(checkbox) }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["style", "href"]),
                      _createVNode(_unref(IonTabButton), {
                        style: _normalizeStyle('--color-selected: ' + _unref(companyStore).activeCompany.color),
                        tab: "Document",
                        href: urlWithId.value + '/document'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(folder) }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["style", "href"]),
                      _createVNode(_unref(IonTabButton), {
                        style: _normalizeStyle('--color-selected: ' + _unref(companyStore).activeCompany.color),
                        tab: "Teams",
                        href: urlWithId.value + '/teams'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(people) }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["style", "href"]),
                      _createVNode(_unref(IonTabButton), {
                        style: _normalizeStyle('--color-selected: ' + _unref(companyStore).activeCompany.color),
                        tab: "Comments",
                        href: urlWithId.value + '/comments'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(chatbubble) }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["style", "href"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})